/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains keywords of current page/template
 */
export const keywordsContextKey = "keywords";
